import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { trackStoreClick } from "@/lib/onboardingAnalytics";

const APP_STORE_URL = "https://apps.apple.com/app/gitfit-ai/id6754495386";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=ai.gitfit.app&pcampaignid=web_share";

interface IOSAppPromotionDialogProps {
  open: boolean;
  onContinueOnWeb: () => void;
}

export const IOSAppPromotionDialog = ({

  open,
  onContinueOnWeb,
}: IOSAppPromotionDialogProps) => {
  const { t } = useTranslation();
  const handleOpenAppStore = () => {
    trackStoreClick("apple", "promotion_dialog");
    window.open(APP_STORE_URL, "_blank");
  };

  const handleOpenPlayStore = () => {
    trackStoreClick("google", "promotion_dialog");
    window.open(PLAY_STORE_URL, "_blank");
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-2xl text-center">{t('ui.text.get_a_better_experience_on_the_app')}</DialogTitle>
          <DialogDescription className="text-center pt-2">
            Download the native app for the best experience with enhanced features
            and better performance.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex flex-col gap-2 sm:flex-col">
          <div className="flex gap-2 w-full">
            <Button
              onClick={handleOpenAppStore}
              className="flex-1"
              size="lg"
            >
              <ExternalLink className="mr-2 h-4 w-4" />App Store
            </Button>
            <Button
              onClick={handleOpenPlayStore}
              className="flex-1"
              size="lg"
            >
              <ExternalLink className="mr-2 h-4 w-4" />Play Store
            </Button>
          </div>
          <Button
            variant="outline"
            onClick={onContinueOnWeb}
            className="w-full"
            size="lg"
          >{t('ui.text.continue_on_web')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
